@if (formGroup) {
  <article #resizeableContainer [class.with-more-options]="showMoreOptionsBtn" [appResizeObserver]="resizeableContainer" (resized)="componentResized($event)">
    <form [formGroup]="formGroup">
      <button type="submit" style="display: none">hidden submit</button>
      <section class="primary-options-wrapper" [class.compact]="compact">
        <div class="primary-options">
          @if (!listOptions) {
            <app-form-field-text
              [id]="'table-filter-field-' + field"
              [formGroup]="formGroup"
              [field]="field"
              icon="search"
              [label]="label | translate"
              [clearable]="true"
              [errors]="[{ error: 'maxlength', messageKey: 'commons.validations.maxLength' }]"
              appearance="fill"
            ></app-form-field-text>
          }
          @if (listOptions) {
            <app-form-field-auto
              [formGroup]="formGroup"
              [field]="field"
              icon="search"
              [label]="label | translate"
              [clearable]="true"
              [errors]="[{ error: 'maxlength', messageKey: 'commons.validations.maxLength' }]"
              [listOptions]="listOptions"
              [displayFn]="displayFn"
              [lazyLoad]="lazyLoad"
              appearance="fill"
              >
            </app-form-field-auto>
          }
          <ng-content select=".primary"></ng-content>
        </div>
        @if (showMoreOptionsBtn) {
          <div class="footer-container">
            <button id="table-filters-expand-btn" mat-button (click)="expanded = !expanded" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
              @if (!expanded && !summary) {
                <span>{{ 'uix.grid.options.expand' | translate }}</span>
              }
              @if (!expanded && summary) {
                <mat-icon>filter_alt</mat-icon>
              }
              @if (!expanded && summary) {
                <span class="summary">{{ summary }}</span>
              }
              @if (expanded) {
                <span>{{ 'uix.grid.options.hide' | translate }}</span>
              }
            </button>
            @if (!expanded && summary) {
              <button id="clear-summary-btn" mat-button (click)="clearSummary.next()">
                <mat-icon>close</mat-icon>
              </button>
            }
            <ng-template
              cdkConnectedOverlay
              (backdropClick)="expanded = !expanded"
              [cdkConnectedOverlayHasBackdrop]="true"
              [cdkConnectedOverlayOrigin]="trigger"
              [cdkConnectedOverlayOpen]="expanded"
              (overlayKeydown)="overlayKeydown($event)"
              [cdkConnectedOverlayBackdropClass]="'transparent-backdrop'"
              >
              <div class="options-wrapper">
                <ng-content select=".more"></ng-content>
                <button id="options-overlay-done-btn" mat-button (click)="expanded = !expanded">
                  <span>{{ 'commons.btn.done' | translate }}</span>
                </button>
              </div>
            </ng-template>
          </div>
        }
      </section>
      <section class="actions">
        <div class="actions-wrapper">
          @if (!compact || !menuActionsTemplateRef) {
            @if (!actionsTemplateRef) {
              <ng-content select=".actions"></ng-content>
            }
            @if (actionsTemplateRef) {
              <ng-container *ngTemplateOutlet="actionsTemplateRef"></ng-container>
            }
          }
          @if (compact && compactModeOnActions && menuActionsTemplateRef && viewWidth > 400) {
            <button mat-button [mat-menu-trigger-for]="compactModeMenu">
              <mat-icon>arrow_drop_down</mat-icon>
              <span>{{ 'commons.btn.options' | translate }}</span>
            </button>
          }
          @if (compact && compactModeOnActions && menuActionsTemplateRef && viewWidth <= 400) {
            <button mat-icon-button [mat-menu-trigger-for]="compactModeMenu">
              <mat-icon>menu</mat-icon>
            </button>
          }
          <mat-menu #compactModeMenu>
            @if (!menuActionsTemplateRef) {
              <ng-content select=".menu-actions"></ng-content>
            }
            @if (menuActionsTemplateRef) {
              <ng-container *ngTemplateOutlet="menuActionsTemplateRef"></ng-container>
            }
          </mat-menu>
        </div>
      </section>
    </form>
  </article>
}
